module.exports = __webpack_public_path__ + "img/Union.460f26c5.svg";